import { handleError } from '@anchorage/sentry/errors';
import { startOfDay } from 'date-fns/startOfDay';
import { startOfMonth } from 'date-fns/startOfMonth';
import { startOfQuarter } from 'date-fns/startOfQuarter';
import { startOfWeek } from 'date-fns/startOfWeek';
import { startOfYear } from 'date-fns/startOfYear';

import { convertDateToNanos } from './convertDateToNanos';
import { DATE_UNITS } from './types';

/**
 * @param unit
 */
export function getNanosAtStartOf(unit: DATE_UNITS): string {
  let startFn;
  switch (unit) {
    case DATE_UNITS.TODAY:
      startFn = startOfDay;
      break;
    case DATE_UNITS.WEEK:
      startFn = startOfWeek;
      break;
    case DATE_UNITS.MONTH:
      startFn = startOfMonth;
      break;
    case DATE_UNITS.QUARTER:
      startFn = startOfQuarter;
      break;
    case DATE_UNITS.YEAR:
      startFn = startOfYear;
      break;
    default:
      break;
  }

  if (!startFn) {
    handleError(
      new Error(`getNanosAtStartOf called with invalid unit ${unit}`),
    );
    return '';
  }

  return convertDateToNanos(startFn(Date.now()));
}
